module.exports = __webpack_public_path__ + "static/lxenglish_banner-49bbdfca83e3e5c9ff6554ce5abce6fa.jpg";